import {
  Row,
  Col,
  Accordion,
  Card,
  Tooltip,
  OutlineButton,
  PopupDialogbox,
  PrimaryButton
} from "../../../CommonComponents";
import "./PurchaseOrder.scss";
import "../../../../commonStyles.scss";
import LeaderOrder from "./LeadrOrder";
import VehicleRequestDetail from "./VehicleRequestDetail";
import { useDispatch, useSelector } from "react-redux";
import Completed from "../../../assets/images/PenndingApproval/Approved.svg";
import Moment from "moment";
import { useEffect, useState } from "react";
import { formatLableValue, formatPrice } from "utils";
import { operations as purchaseOrderOperations } from "redux/PurchaseOrder";
import { getRequisitionReasonCode } from "Store/OrderManagement/ReasonCode/ReasonCodeAction";
import Cancelled from "../../../assets/images/MyOrders/Cancelled.svg";
import { CONSTANTS } from "client/utils/constants";
import { getGLAccountCodes } from "Store/FleetManagement/GLAccountCodes/GLAccountCodesAction";
import { isAuthorized } from "client/utils/Permissions";
import { FLEET_PROCESSING_PERMISSIONS } from "client/utils/constants/fleetProcessingPermissions";
import { GetStatusIcon } from "client/utils/IconsUtil";
import Spinner from "client/CommonComponents/Spinner";

interface IProps {
  orderDetails?: any;
  onChangeAccordion?: any;
  dispatchStepperData?: Function;
  savedStatus?: any
  showEditBtn?: any;
  handleItemCancelClick?: any;
  Popupcontent?: any;
  hideConfirmationDialog?: any;
  SavedAdminTaskValue?: any;
  setCancelledItemFleetId?: any;
  isBulkOrder: boolean;
  purchaseOrderStepperDataArr: any;
  cancelledItemFleetId: any;
  setCancelComment?: any;
  cancelComment?: any;
  handleorderLevelReturn?: any;
  getShowOrderReturn?: any;
  onCatalogOverrideSaved?: (fleetId: number) => void;
  accordionResetKey?: number;
  accordionPreExpanded?: string[];
}

const PurchaseOrder = ({
  orderDetails,
  onChangeAccordion,
  savedStatus,
  showEditBtn,
  handleItemCancelClick,
  Popupcontent,
  hideConfirmationDialog,
  SavedAdminTaskValue,
  setCancelledItemFleetId,
  isBulkOrder,
  purchaseOrderStepperDataArr,
  cancelledItemFleetId,
  setCancelComment,
  cancelComment,
  handleorderLevelReturn,
  getShowOrderReturn,
  onCatalogOverrideSaved,
  accordionResetKey = 0,
  accordionPreExpanded = [""],
}: IProps) => {
  const dispatch = useDispatch();
  const dispatchAssignToDropdown =
    purchaseOrderOperations.dispatchAssignToDropdown(dispatch);
  const dispatchOrderTypeDropdown =
    purchaseOrderOperations.dispatchOrderTypeDropdown(dispatch);
  // commented code because api is failing
  useEffect(() => {
    dispatchAssignToDropdown();
    dispatchOrderTypeDropdown();
    dispatch(getRequisitionReasonCode());
    dispatch(getGLAccountCodes());
  }, []);
  
  const [initialItems, setInitialItems] = useState<any[]>([]);
  const [remainingItems, setRemainingItems] = useState<any[]>([]);
  const [loadingRemainingItems, setLoadingRemainingItems] = useState<boolean>(true);
  const ExpandedItemsDetail: any[] = [];

  useEffect(() => {
    if (purchaseOrderStepperDataArr?.length) {
      const first15Items = purchaseOrderStepperDataArr?.slice(0, 15); // Get the first 15 items
      setInitialItems(first15Items);
      const remainingItems = purchaseOrderStepperDataArr?.slice(15); // Get the remaining items
      if (remainingItems.length) {
        setTimeout(() => {
          setRemainingItems(remainingItems); // Simulate background loading
        }, 700); // Simulate delay before loading remaining items
      }
    }
  }, [purchaseOrderStepperDataArr]);

  const ExpandedItems = [
    {
      headerText: (
        <div className="accordionHeader">
          <div className="accordionHeaderLeft mt-1">
            <p className="accord-heading">
              LEADR ORDER# - {orderDetails?.orderRequestId}
            </p>
          </div>
          <div className="accordionHeaderRight mt-sm-0 mt-2">
            <div>
              <label className="labelText ">Order Type{orderDetails?.orderRequestTypes?.length > 1 ? "s" :""}</label>
              <Tooltip content={orderDetails?.orderRequestTypes?.map((item : any, index : any) => {
                  return item + (index + 1 < orderDetails?.orderRequestTypes?.length ? ", " : "")
                })} data-attribute="PurchaseOrder_Default_Tooltip_7">
                  <span className="dateContent orderTypeLbl">
                {orderDetails?.orderRequestTypes?.map((item : any, index : any) => {
                  return item +  (index + 1 < orderDetails?.orderRequestTypes?.length ? ", " : "")
                })}   
                </span>     
              </Tooltip>           
            </div>
            <div>
              <label className="labelText">Created Date</label>
              <Tooltip content= {orderDetails?.createdDate
                    ? Moment(orderDetails?.createdDate).format("MM/DD/YYYY")
                    : "-"} data-attribute="PurchaseOrder_Default_Tooltip_2_2">
                <span className="dateContent">
                  {orderDetails?.createdDate
                    ? Moment(orderDetails?.createdDate).format("MM/DD/YYYY")
                    : "-"}
                </span>
              </Tooltip>
             
            </div>
            <div>
              <label className="labelText">Updated Date</label>
              <Tooltip content= {orderDetails?.updatedDate || SavedAdminTaskValue?.updatedDate
                    ? Moment(SavedAdminTaskValue?.updatedDate ? SavedAdminTaskValue?.updatedDate : orderDetails?.updatedDate).format("MM/DD/YYYY")
                    : "-"} data-attribute="PurchaseOrder_Default_Tooltip_3_2">
                <span className="dateContent">
                  {orderDetails?.updatedDate || SavedAdminTaskValue?.updatedDate
                    ? Moment(SavedAdminTaskValue?.updatedDate ? SavedAdminTaskValue?.updatedDate : orderDetails?.updatedDate).format("MM/DD/YYYY")
                    : "-"}
                </span>
              </Tooltip>              
            </div>
            <div>
              <label className="labelText">Requested By</label>
              <Tooltip content={`${orderDetails?.requestedBy}`} data-attribute="PurchaseOrder_Default_Tooltip_4_2">
                <span className="dateContent">{orderDetails?.requestedBy || "-"}</span>
              </Tooltip>
            </div>
          </div>
        </div>
      ),
      content: <LeaderOrder isBulkOrder={isBulkOrder} key={orderDetails?.orderRequestId} />,
      uuid: "Accordion1",
    },
  ];

  const iconReturn = (status: any) => {
    return <img src={GetStatusIcon(status).icon} alt="statusIcon" className="statusIcon" />;
  };

  const commonmethod = (item: any, index: any) => {
    const getItemStatus = (status: any) => {
      let val = savedStatus?.filter((savedItem?: any) => savedItem?.fleetItemId == item?.fleetRequestDetailId)
      if (val?.length) {
        return iconReturn(val[0]?.itemStatus)
      } else {
        return iconReturn(status)
      }
    }
    const getItemStatusValue = (value: any) => {
      let val = savedStatus?.filter((savedItem?: any) => savedItem?.fleetItemId == item?.fleetRequestDetailId)
      if (val?.length) {
        return formatLableValue(val[0]?.itemStatus)
      } else { return formatLableValue(value) }
    }
    const getFleetItemStatus = (status: any) => {
      let val = savedStatus?.filter((savedItem?: any) => savedItem?.fleetItemId == item?.fleetRequestDetailId)
      if (val?.length) {
        return iconReturn(val[0]?.fleetStatus)
      } else { return iconReturn(status) }
    }
    const getFleetItemStatusValue = (value: any) => {
      let val = savedStatus?.filter((savedItem?: any) => savedItem?.fleetItemId == item?.fleetRequestDetailId)
      if (val?.length) {
        return formatLableValue(val[0]?.fleetStatus)
      } else { return formatLableValue(value) }
    }
    const isShowComplete = (value: any) => {
      let val = savedStatus?.filter((savedItem?: any) => savedItem?.fleetItemId == item?.fleetRequestDetailId)
      if (val?.length) {
        if (val[0]?.fleetStatus == CONSTANTS?.ORDER_STATUS?.REQUISITION_COMPLETE) {
          return true
        } else {
          return false
        }
      } else if (value == CONSTANTS?.ORDER_STATUS?.REQUISITION_COMPLETE) {
        return true
      }
      else { return false }
    }
    ExpandedItemsDetail.push({
      headerText: (
        <div className="LeaderOrderHeader driverDetail">
          <div className={`LeadrOrderSubTitle ${showEditBtn ? 'edit-ui' : ''}`}>
            <div className="itemId">
              <p className="label">Item ID</p>
              <Tooltip content={item?.itemId} data-attribute="PurchaseOrder_Default_Tooltip_5_2"><p>{item?.itemId}</p></Tooltip>
            </div>
            <div className="vehicletype">
            <div className="itemId">
              {/*included the Request Type*/}
              <p className="label">Request Type</p>
              {
                item?.orderRequestType === CONSTANTS?.VEHICLE_REQUEST ? 
                <Tooltip content={item?.orderRequestSubType} data-attribute="PurchaseOrder_Default_Tooltip_6_2"><p>{item?.orderRequestSubType}</p></Tooltip>
                :
                <Tooltip content={item?.orderRequestType} data-attribute="PurchaseOrder_Default_Tooltip_7_2"><p>{item?.orderRequestType}</p></Tooltip>
              }
            </div>
            </div>
            <div className="itemStatus">
              <p className="label">Item Status</p>
                <p className="fleetValue">
                  <span>{getItemStatus(item?.itemStatus)}</span>
                  <span>{getItemStatusValue(item?.itemStatus)}</span>
                </p>          
            </div>
            <div className="fleetSatus">
              <p className="label">Fleet Status</p>
              <p className="fleetValue">
                <span>{getFleetItemStatus(item?.fleetStatus)}</span>
                <span>{getFleetItemStatusValue(item?.fleetStatus)}</span>
              </p>
            </div>
            <div className="CipPool">
                <p className="label">Asset #</p>
                <Tooltip content={item?.assetAfterSave ?? '-' } data-attribute="PurchaseOrder_Default_Tooltip_8"><p>{item?.assetAfterSave ?? '-'}</p></Tooltip>
              </div>
            {item?.pocipDetails?.hasOwnProperty('cippoNumber') ?
              <div className="CipPool">
                <p className="label">CIP Pool #</p>
                <Tooltip content={item?.pocipDetails?.cippoNumber} data-attribute="PurchaseOrder_Default_Tooltip_9"><p>{item?.pocipDetails?.cippoNumber}</p></Tooltip>
              </div>
              : 
              <div className="CipPool">
                <p className="label">PO #</p>
                <Tooltip content={item?.poNumber ?? '-'} data-attribute="PurchaseOrder_Default_Tooltip_10"><p>{item?.poNumber ?? '-'}</p></Tooltip>
              </div>}
            <div>
              {isShowComplete(item?.fleetStatus) ? (
                <img
                  src={Completed}
                  alt="status"
                  title="status"
                  className="me-1"
                />
               ) : null}
              {
                 item?.fleetStatus == CONSTANTS.ORDER_STATUS.CANCELLED ? (
                  <img
                    src={Cancelled}
                    alt="status"
                    title="status"
                    className="me-1 cancelFleetIcon"
                  />
                 ) : null
              }
              
            </div>
            {
              showEditBtn(item?.fleetStatus, item?.fleetRequestDetailId) ? 
              <div className="btn-edit-cancel-fleet">
                <OutlineButton text='Cancel Item' title='Cancel Item' onClick={(e?: any) => handleItemCancelClick(e,item?.fleetRequestDetailId)} disabled={!isAuthorized(FLEET_PROCESSING_PERMISSIONS?.DELETE_PURCHASEORDERS)} data-attribute="PurchaseOrder_Cancel_Item_Button" />
                <span className="fa fa-pencil hide" title='Edit'></span>
              </div> : ''
            }                     
            <div className="price">
              <p className="">Price</p>
              <p>
                <b className="boldFont">
                  ${formatPrice(item?.pricePerUnit ? item?.pricePerUnit : 0, 2)}
                </b>
              </p>
            </div>
          </div>
        </div>
      ),
      content: (
        <VehicleRequestDetail 
        itemDetails={item} 
        accordionIndex={index} 
        isShowComplete={isShowComplete} 
        setCancelledItemFleetId = {setCancelledItemFleetId}
        cancelledItemFleetId={cancelledItemFleetId}
        isBulkOrder={isBulkOrder}
        key={item?.fleetRequestDetailId}
        setCancelComment = {setCancelComment}
        cancelComment = {cancelComment}
        onCatalogOverrideSaved={onCatalogOverrideSaved}
        />
      ),
        uuid: `Accordion${index}`,
      fleetRequestId: item.fleetRequestDetailId,
      requestDetailId: item.requestDetailId,
    });
  };
  
    if (initialItems.length) {
        initialItems.forEach((item: any, index: any) => {
      commonmethod(item, index)
      if((index + 1) === purchaseOrderStepperDataArr?.length && loadingRemainingItems && purchaseOrderStepperDataArr?.length > 0 ){
        setLoadingRemainingItems(false)
      }
    });
  }

  if (remainingItems.length) {
      remainingItems.forEach((item: any, index: any) => {
      commonmethod(item, index + 15)
      if((index + 16)=== purchaseOrderStepperDataArr?.length && loadingRemainingItems && purchaseOrderStepperDataArr?.length > 0 ){
        setLoadingRemainingItems(false)
      }
    });
  }

  return (
    <div className="fleetProcessing mt-0">
      <Row>
        <Col xs={12} lg={12} className="BudgetCard DropDownAlligment">
          <div className="card-radius">
          <Card data-attribute="PurchaseOrder_Default_Card">
            <Accordion
              Items={ExpandedItems}
              preExpanded={["Accordion1", "Accordion2"]}
              className="custom-accordion LeaderOrderAccordion"
             data-attribute="PurchaseOrder_Default_Accordion" />
          </Card>
          </div>
          {!!ExpandedItemsDetail.length && (
            <>
              {loadingRemainingItems ? (
                <div className="loader-container">
                  <Spinner text={'Loading ...'}  data-attribute="PurchaseOrder_Default_Spinner" />
                </div>
              ) : (
                <Card data-attribute="PurchaseOrder_Default_Card_2">
                  <Accordion
                    key={accordionResetKey}
                    Items={ExpandedItemsDetail}
                    preExpanded={accordionPreExpanded}
                    allowZeroExpanded
                    onChange={(item: any) => onChangeAccordion(ExpandedItemsDetail, item)}
                    className="custom-accordion"
                   data-attribute="PurchaseOrder_Default_Accordion_2" />
                  <div className="clearfix">
                    {getShowOrderReturn(purchaseOrderStepperDataArr) ? (
                      <div className="pull-right">
                        <PrimaryButton
                          text="Return Entire Order to Requestor"
                          className="me-0"
                          onClick={(e: any) => handleorderLevelReturn(e, purchaseOrderStepperDataArr)}
                         data-attribute="PurchaseOrder_Default_Button_2" />
                      </div>
                    ) : null}
                  </div>
                </Card>
              )}
            </>
          )}
        </Col>
      </Row>
      {
        Popupcontent.isDialogVisible && (
          <PopupDialogbox
            hideDialog={!Popupcontent.isDialogVisible}
            onDismiss={hideConfirmationDialog}
            Popupcontent={Popupcontent}
            popupOutlinebtnOnclick={() => Popupcontent?.popupOutlinebtnOnclick()}
            popupPrimarybtnOnclick={(
              item: any,
              actionby: string,
              value: any) => Popupcontent?.popupPrimarybtnOnclick(item,
                actionby,
                value)}
           data-attribute="PurchaseOrder_Default_PopupDilalogBox" />
        )
      }
    </div>   
  );
};

export default PurchaseOrder;